import { head } from '@fxts/core';
import { hydrationRune } from '../../../../modules/MShop/Util/F/Function/util.js';

/**
 * Hydrates the given view class using Rune and returns the view instance.
 * @returns The initialized view instance or null if not found.
 */
export const hydrateRuneAndGetView = <V>(viewClass: new (...args: any[]) => V): V | undefined => {
  return head(hydrateRuneAndGetViews(viewClass));
};

export const hydrateRuneAndGetViews = <V>(viewClass: new (...args: any[]) => V): V[] => {
  return hydrationRune(viewClass);
};
